import React, { FC, useEffect, useState } from 'react';
import { DEF_PG_SIZE_SUB_MIN } from '../../constants/maximum-page-size';
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from '../../contexts/table/TableContextProvider';
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from '../../models/ColumnDefinitions/DeviceInputColumns';
import { ListQuery } from '../../models/ListQuery';
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import SiteSearch from '../../models/search/SiteSearch';
import { getDeviceInputs } from '../../services/deviceInputService';
import { getSiteNamesWithPagination } from "../../services/siteService";
import TableTab from "../tabs/table-tab";
import { getDeviceSettingsTableLegendItems } from "../../models/TableLegend"
interface Props {
    itemId: string;
}

const DeviceInputs: FC<Props> = ({ itemId}) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.assignedInputs);
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    return <TableContextProvider
        dataMethod={(listParameters?: ListQuery) => getDeviceInputs(itemId, translate, listParameters)}
        tableDescriptor={columns}
        legendItems={getDeviceSettingsTableLegendItems(translate)}
        useLegend
        usePagination
        useFilter
        useSort
        useTable
        maxPageSize={DEF_PG_SIZE_SUB_MIN}
        disableSearch={true}
        lookup={lookup}>
        <TableTab
            title={title}
            selectRows={false}
            cyName='deviceInputs'/>
    </TableContextProvider>
};

export default DeviceInputs;
